export enum PageState {
	Loaded = "Loaded",
	Loading = "Loading",
	NotFound = "NotFound",
}
